import type { FlagConfiguration } from '@atlassian/jira-flags';
import { messages } from '../../common/messages';

export const createProjectsConnectionSuccessFlagConfig = (
	projectName: string,
): FlagConfiguration => ({
	testId:
		'business-calendar.ui.calendar-view.toolbar.more-menu.more-menu-content.connected-project-select.projects-connection-success-flag',
	type: 'success',
	title: [messages.projectsConnectionSuccessFlagHeading, { projectName }],
	description: messages.projectsConnectionSuccessFlagText,
});

export const createProjectsConnectionFailureFlagConfig = (): FlagConfiguration => ({
	testId:
		'business-calendar.ui.calendar-view.toolbar.more-menu.more-menu-content.connected-project-select.projects-connection-failure-flag',
	type: 'error',
	title: messages.projectsConnectionFailureFlagHeading,
	description: messages.projectsConnectionFailureFlagText,
});

export const createProjectsDisconnectionSuccessFlagConfig = (
	projectName: string,
): FlagConfiguration => ({
	testId:
		'business-calendar.ui.calendar-view.toolbar.more-menu.more-menu-content.connected-project-select.projects-disconnection-success-flag',
	type: 'success',
	title: [messages.projectsDisconnectionSuccessFlagHeading, { projectName }],
	description: messages.projectsDisconnectionSuccessFlagText,
});
